export function copy(object: unknown) {
    return JSON.parse(JSON.stringify(object));
}
